import { twMerge } from 'tailwind-merge';

import { VabsPaymentDirection, VabsPaymentSystem } from '@/shared/api';
import { Typography } from '@/shared/ui';

import { ITransaction } from '../model/types';

interface TransactionLabelProps {
  transaction: ITransaction;
  className?: string;
}

const getLabel = (item: VabsPaymentDirection, system: VabsPaymentSystem): string => {
  const isExchange = system === VabsPaymentSystem.Exchange
  return item === VabsPaymentDirection.Incoming ? isExchange ? 'Exchange' : 'Top-up' : 'Send';
};

export const TransactionLabel = ({
  transaction,
  className,
}: TransactionLabelProps) => {
  const exchangeName = transaction.paymentSystem === VabsPaymentSystem.Exchange ? `${transaction.sourceCurrency} → ${transaction.targetCurrency}` : ''
  return (
    <div className="flex flex-col gap-1">
      <Typography
        variant="16-r"
        className={twMerge(
          'max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap',
          className,
        )}
      >
        {exchangeName || transaction.name}
      </Typography>
      <Typography variant="14-r" color="text-base-100" className="capitalize">
        {getLabel(transaction.type, transaction.paymentSystem)}
      </Typography>
    </div>
  );
};
